{
  "auditLogs": {
    "title": "Audit Logs",
    "description": "View all data mutations across tenant entities",
    "timestamp": "Timestamp",
    "actor": "Actor",
    "action": "Action",
    "entityType": "Entity Type",
    "entityId": "Entity ID",
    "summary": "Summary",
    "scope": "Scope",
    "superadminScope": "Superadmin",
    "filterByThisActor": "Filter by this actor",
    "filterByThisEntity": "Filter by this entity type",
    "filterByThisEntityId": "Filter by this entity ID",
    "fieldChanges": "Field Changes",
    "batchInfo": "Batch Info",
    "snapshot": "Document Snapshot",
    "empty": "No audit logs found",
    "showing": "Showing {{from}}-{{to}} of {{total}}",
    "previous": "Previous",
    "next": "Next",
    "systemActor": "System",
    "ip": "IP",
    "endpoint": "Endpoint",
    "sessionId": "Session ID",
    "actionCreate": "Create",
    "actionUpdate": "Update",
    "actionSoftDelete": "Soft Delete",
    "actionDestroy": "Destroy",
    "actionBulkSoftDelete": "Bulk Soft Delete",
    "actionBulkDestroy": "Bulk Destroy",
    "actionBulkWrite": "Bulk Write",
    "field": "Field",
    "from": "From",
    "to": "To",
    "batchFilter": "Filter",
    "batchUpdate": "Update",
    "batchMatched": "Matched",
    "batchModified": "Modified",
    "noDetails": "No details available",
    "fieldsChanged": "{{count}} field(s) changed",
    "matchedModified": "{{matched}} matched, {{modified}} modified",
    "snapshotCaptured": "Snapshot captured"
  },
  "tenantAdmin": {
    "title": "Tenants",
    "description": "Manage all tenants in the system",
    "createTenant": "Create Tenant",
    "editTenant": "Edit Tenant",
    "updateTenant": "Update Tenant",
    "createDescription": "Add a new tenant to the system",
    "cloneTenant": "Clone Tenant",
    "cloneDescription": "Create an independent copy of {{name}}, including all of its data.",
    "cloneNameDefault": "Copy of {{name}}",
    "cloneWarningTitle": "Users are copied along",
    "cloneWarning": "The clone copies all users with their existing logins. Each user can sign in to both tenants with the same email and password.",
    "cloneStarted": "The clone is running in the background. The new tenant becomes active once it finishes.",
    "cloneRunningBadge": "creating…",
    "cloneRunningTooltip": "Clone running in the background: {{phase}}",
    "clonePhaseCopying": "copying data",
    "clonePhaseProvisioning": "setting up accounts",
    "clonePhaseImporting": "importing demo logins",
    "cloneInterruptedBadge": "Clone interrupted",
    "cloneFailedBadge": "Clone failed",
    "cloneImportFailedBadge": "Demo logins missing",
    "cloneImportFailed": "Tenant was cloned and is ready, but the demo logins could not be set up. Nobody can sign in to it until the import is re-run.",
    "cloneCompletedBadge": "Notice left over",
    "cloneCompleted": "The clone finished and the tenant is ready. Only this notice could not be cleared automatically — dismissing it is safe.",
    "cloneInterruptedAlertTitle": "Cloning {{name}} was interrupted",
    "cloneInterruptedAlert": "The clone was interrupted and never finished. Nothing was deleted: the incomplete tenant ({{slug}}) still exists and is inactive. “Discard and delete” removes it together with its database and memberships, “Ignore” keeps it and only hides this notice.",
    "cloneFailedAlertTitle": "Cloning {{name}} failed",
    "cloneFailedAlert": "The clone failed and was rolled back. Anything left over from the incomplete tenant ({{slug}}) is inactive. “Discard and delete” removes what remains together with its database and memberships, “Ignore” keeps it and only hides this notice.",
    "cloneDiscardPartialAlertTitle": "Discarding {{name}} was incomplete",
    "cloneDiscardPartialAlert": "A discard already ran and only partly succeeded. Failed: {{steps}}. Everything else was removed.",
    "cloneDiscardPartialRetry": "The tenant and its database are still there — the discard can be run again.",
    "cloneDiscardPartialManual": "The tenant and its database are already gone; the leftovers above have to be cleaned up by hand. “Ignore” only hides this notice.",
    "cloneCleanupStepRevokeMemberships": "revoking memberships",
    "cloneCleanupStepDeactivateZitadelOrg": "deactivating the Zitadel organization",
    "cloneCleanupStepDropDatabase": "dropping the database",
    "cloneCleanupStepDeleteTenantRow": "deleting the tenant record",
    "cloneDiscard": "Discard and delete",
    "cloneDismiss": "Ignore",
    "cloneDiscardTitle": "Discard incomplete clone",
    "cloneDiscardDescription": "The tenant {{name}}, its database and every membership created along the way are deleted permanently. This action cannot be undone.",
    "cloneDiscardSuccess": "Incomplete clone discarded",
    "cloneDiscardPartial": "The copy could only be removed partially. The notice stays until the leftovers are cleaned up.",
    "cloneDismissSuccess": "Notice dismissed",
    "cloneFailed": "Failed to clone tenant",
    "editDescription": "Update the tenant information",
    "searchPlaceholder": "Search tenants...",
    "tenantName": "Tenant Name",
    "tenantNamePlaceholder": "Enter tenant name",
    "tenantNameRequired": "Tenant name is required",
    "tenantSlug": "Tenant Slug",
    "tenantSlugPlaceholder": "tenant-slug",
    "tenantSlugRequired": "Tenant slug is required",
    "tenantSlugPattern": "Slug must be lowercase letters, numbers, and hyphens only",
    "tenantSlugHelper": "URL-friendly identifier (auto-generated from name)",
    "tenantType": "Tenant Type",
    "tenantTypePlaceholder": "Select tenant type",
    "tenantTypeCustomer": "Customer",
    "tenantTypePartner": "Partner",
    "expirationDate": "Expiration Date",
    "expirationHelper": "Leave empty for no expiration",
    "cancel": "Cancel",
    "createFailed": "Failed to create tenant",
    "updateFailed": "Failed to update tenant",
    "columnName": "Name",
    "columnSlug": "Slug",
    "columnType": "Type",
    "columnAccount": "Account",
    "accountLabel": "Account: {{name}}",
    "noAccount": "No account",
    "columnStatus": "Status",
    "columnExpires": "Expires",
    "columnMembers": "Members",
    "columnProcesses": "Processes",
    "filterAll": "All",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "expiresNever": "Never",
    "hideExpired": "Hide expired",
    "deleteSuccess": "Tenant deleted successfully",
    "deleteFailed": "Failed to delete tenant",
    "deleteTitle": "Delete Tenant",
    "deleteDescription": "Are you sure you want to delete this tenant? This will also delete all associated data. This action cannot be undone.",
    "deleteConfirmInstruction": "Type <strong /> to confirm deletion.",
    "deleteConfirmPlaceholder": "Type tenant name to confirm",
    "cloneWarningDemoTitle": "Demo: fresh logins are created",
    "cloneWarningDemo": "The clone copies all users, but every email is rewritten to a fresh demo address (e.g. demo+jane.doe.12@bliks.io) and all users get the demo password set below. Users of earlier demos cannot access this one.",
    "tenantTypeDemo": "Demo",
    "tenantDescription": "Note",
    "tenantDescriptionPlaceholder": "e.g. Demo for company XYZ",
    "columnDescription": "Note",
    "demoPassword": "Demo password",
    "demoPasswordRequired": "Demo password required: at least 8 characters with an uppercase letter, a lowercase letter, and a digit",
    "demoPasswordHint": "Shared password for every user of this demo. At least 8 characters, with an uppercase letter, a lowercase letter, and a digit.",
    "homeOrgLabel": "Home organization",
    "homeOrgNotSet": "Not set",
    "homeOrgMoveWarningTitle": "Sign-in account will be re-created",
    "homeOrgMoveWarning": "Moving this user to another home organization re-creates their sign-in account. Their password, passkeys and MFA are lost, active sessions cannot step up until they complete the new invitation, and a new invitation email is sent.",
    "homeOrgNoTargets": "This person is not a member of any SSO organization that can be set as their home organization.",
    "homeOrgDeletedBadge": "Home organization deleted",
    "homeOrgDeletedTooltip": "This user's home organization was deleted — sign-in is (or will be) blocked. Assign a new home organization to restore access.",
    "homeOrgDeletedAlertTitle": "Home organization deleted — account locked",
    "homeOrgDeletedAlert": "This user's home organization was deleted, so their sign-in is (or will be) blocked. Select a new home organization below to restore access.",
    "homeOrgDeletedNoTargetsAlert": "This user's home organization was deleted, so their sign-in is (or will be) blocked. No eligible target organization is available — first grant the user a membership in an SSO organization, then assign it as the new home organization.",
    "hubspotCompanyId": "HubSpot Company ID",
    "hubspotCompanyIdPlaceholder": "e.g. 340997605594",
    "hubspotPartnerCompanyIdHelper": "HubSpot company id of the partner firm (type \"Partner\").",
    "cloneSource": "Template",
    "cloneSourceHint": "All data is copied from this workspace.",
    "cloneSourcePlaceholder": "Choose a workspace",
    "cloneSourceRequired": "Please choose a workspace to copy from",
    "createDemo": "Create demo",
    "createDemoDescription": "A demo starts as a copy of an existing workspace — it brings that content along, but gets its own credentials.",
    "hubspotCompanyIdHelper": "HubSpot company id of this customer. Bridges the HubSpot company to this Bliks tenant."
  },
  "recordingAnalytics": {
    "title": "Recording Analytics",
    "description": "Average active recording time per process, across tenants",
    "scope": "Tenant",
    "allTenants": "All tenants",
    "empty": "No recording-time data yet",
    "tenant": "Tenant",
    "process": "Process",
    "minutesSuffix": "{{value}} min",
    "avgPerStep": "Avg. time per step",
    "avgPerProcess": "Avg. time per process",
    "acrossSteps": "across {{count}} step recordings",
    "acrossProcesses": "across {{count}} processes",
    "processCount": "Processes",
    "stepCount": "Steps",
    "total": "Total time",
    "step": "Step",
    "stepTime": "Recording time"
  },
  "aiUsage": {
    "title": "AI Usage",
    "description": "AI cost and token usage per tenant",
    "tenantTabDescription": "All-time AI cost and token usage for this tenant, by source and model",
    "scope": "Tenant",
    "allTenants": "All tenants",
    "range": "Time range",
    "range7d": "Last 7 days",
    "range30d": "Last 30 days",
    "range90d": "Last 90 days",
    "rangeAll": "All time",
    "empty": "No AI usage recorded",
    "loadError": "Failed to load AI usage data",
    "tenant": "Tenant",
    "totalCost": "Total cost",
    "cost": "Cost",
    "calls": "Calls",
    "callsBreakdown": "{{generation}} generations · {{embedding}} embeddings · {{transcription}} transcriptions",
    "acrossCalls_one": "across {{count}} call",
    "acrossCalls_other": "across {{count}} calls",
    "tokens": "Tokens",
    "tokensBreakdown": "{{input}} in · {{output}} out",
    "transcription": "Transcription",
    "minutesSuffix": "{{value}} min",
    "source": "Source",
    "unknownSource": "Unknown source",
    "kind": "Type",
    "kindFeature": "Feature",
    "kindApp": "App",
    "model": "Model",
    "inputTokens": "Input tokens",
    "outputTokens": "Output tokens",
    "priceMissingEvents_one": "{{count}} call had no price entry and is counted with cost 0",
    "priceMissingEvents_other": "{{count}} calls had no price entry and are counted with cost 0",
    "priceMissingWarning_one": "{{count}} call had no price entry — cost totals undercount",
    "priceMissingWarning_other": "{{count}} calls had no price entry — cost totals undercount",
    "failedTenantsWarning_one": "{{count}} tenant could not be read — totals are incomplete",
    "failedTenantsWarning_other": "{{count}} tenants could not be read — totals are incomplete"
  },
  "partnerContent": {
    "title": "Partner content",
    "description": "What every sales partner sees: documents and videos in the Info Hub and the news on their home page.",
    "tabs": {
      "materials": "Info Hub",
      "news": "News"
    },
    "status": {
      "published": "Published",
      "draft": "Draft"
    },
    "filter": {
      "all": "All"
    },
    "emptyFiltered": "Nothing matches the filter.",
    "columns": {
      "order": "Order",
      "title": "Title",
      "status": "Status",
      "languages": "Languages",
      "updatedAt": "Changed",
      "publishedAt": "Published on"
    },
    "actions": {
      "publish": "Publish",
      "unpublish": "Unpublish",
      "saveDraft": "Save as draft",
      "undo": "Undo",
      "moveUp": "Move up",
      "moveDown": "Move down"
    },
    "toast": {
      "published": "Published. Partners see it now.",
      "saved": "Saved as draft.",
      "saveFailed": "Saving failed. Please try again."
    },
    "completeness": {
      "complete": "complete",
      "partial": "incomplete",
      "empty": "missing"
    },
    "languages": {
      "title": "Languages",
      "contentTitle": "Content per language",
      "hint": "German is required. Where a language is missing, partners see the English version, else the German one.",
      "present": "{{language}} available",
      "missing": "{{language}} missing"
    },
    "fields": {
      "titleIn": "Title ({{language}})",
      "descriptionIn": "Description ({{language}})"
    },
    "materials": {
      "add": "Add document",
      "createTitle": "New document",
      "editTitle": "Edit document",
      "dialogDescription": "Appears in every partner’s Info Hub once published.",
      "general": "General",
      "kind": "Type",
      "kinds": {
        "file": "File",
        "video": "Video"
      },
      "kindHints": {
        "file": "PDF, PowerPoint, Word or Excel, one file per language",
        "video": "A YouTube video"
      },
      "videoUrl": "YouTube link",
      "videoPreview": "Video thumbnail",
      "needsFile": "A document needs at least one file to be published.",
      "empty": "No documents yet. Add the first one.",
      "loadError": "The documents could not be loaded.",
      "deleteEntityPhrase": "this document and its files",
      "files": {
        "label": "File",
        "dropTitle": "Drop the {{language}} file here",
        "dropHint": "PDF, PowerPoint, Word or Excel, up to 25 MB",
        "choose": "Choose the {{language}} file",
        "replace": "Replace",
        "remove": "Remove the {{language}} file",
        "uploadOnSave": "uploads on save",
        "removedOnSave": "{{name}} will be removed on save.",
        "rejected": {
          "format": "Allowed are PDF, PowerPoint, Word and Excel.",
          "size": "The file is larger than 25 MB."
        }
      }
    },
    "news": {
      "add": "Write news",
      "createTitle": "New news entry",
      "editTitle": "Edit news entry",
      "dialogDescription": "Appears on the partners’ home page once published; the audience decides whose.",
      "general": "General",
      "pinned": "Show first",
      "pin": "Show first",
      "unpin": "Stop showing first",
      "bodyIn": "Text ({{language}})",
      "preview": "Preview",
      "previewHint": "How partners see the news in {{language}}.",
      "empty": "No news yet. Write the first one.",
      "loadError": "The news could not be loaded.",
      "deleteEntityPhrase": "this news entry",
      "eyebrow": "Eyebrow",
      "eyebrowIn": "Eyebrow ({{language}})",
      "footnoteIn": "Footnote ({{language}})",
      "links": "Buttons",
      "primaryAction": "Main button",
      "secondaryAction": "Second button",
      "actionLabelIn": "Label of the {{action}} ({{language}})",
      "images": {
        "title": "Pictures",
        "logo": "Logo",
        "logoHint": "Shown on top, e.g. OMR and G2 in one picture. PNG, JPG, WebP or SVG, up to 2 MB.",
        "image": "Image",
        "imageHint": "Shown square beside the text. PNG, JPG, WebP or SVG, up to 2 MB.",
        "choose": "Choose the {{label}}",
        "remove": "Remove the {{label}}",
        "rejected": {
          "format": "Allowed are PNG, JPG, WebP and SVG.",
          "size": "The picture is larger than 2 MB."
        }
      },
      "audience": "Audience",
      "audienceHint": "Every partner, or only partners running the sales app.",
      "audienceAll": "All partners",
      "audienceSales": "Sales-app users"
    }
  },
  "accountAdmin": {
    "addAccount": "Add account",
    "addAccountHint": "Search the company that becomes the customer — the HubSpot id is what gets assigned.",
    "addTenant": "Add workspace",
    "assignCompany": "Assign company",
    "assignCompanyHint": "Search by name or domain — what gets assigned is always the HubSpot id, never the name.",
    "backToAccounts": "Back to accounts",
    "changeCompany": "Change company",
    "childCount": "{{count}} below",
    "children": "Child accounts",
    "columnGroup": "Group",
    "columnName": "Customer",
    "columnTenants": "Workspaces",
    "companiesUnavailable": "Company names could not be loaded from HubSpot — the accounts are complete, only the names are missing.",
    "company": {
      "ambiguous": {
        "primary": "Several contacts carry the primary-contact label. The first one wins — please make it unambiguous in the CRM.",
        "billing": "Several contacts carry the billing-contact label. The first one wins — please make it unambiguous in the CRM."
      },
      "billingContactRole": "Invoice",
      "contactUnnamed": "Contact without a name",
      "heading": "Company in the CRM",
      "noAddress": "No address kept in the CRM",
      "noBillingContact": "No billing contact labelled in the CRM",
      "noBillingEmail": "No invoice recipient kept",
      "noContact": "No primary contact labelled in the CRM",
      "noVatId": "No VAT ID kept",
      "primaryContactRole": "Offer",
      "refresh": "Refresh from HubSpot",
      "refreshChanged": "Master data taken from HubSpot.",
      "refreshUnchanged": "Read HubSpot — nothing new.",
      "refreshUnread": "HubSpot could not be read. The last known state still applies.",
      "unknownName": "Name unknown",
      "unlinked": "No company linked yet",
      "vatConfirmed": "confirmed",
      "vatRejected": "not confirmed",
      "vatUnchecked": "unchecked"
    },
    "companyTaken": "Already assigned",
    "createCompany": "Create “{{name}}” in HubSpot",
    "createWithoutCompany": "Create without a company",
    "description": "The customers — one account per legal entity, which may run several workspaces.",
    "detachParent": "Detach",
    "empty": "No accounts yet.",
    "group": "Group",
    "groupHint": "Accounts can be nested under one umbrella — a corporate group, a chain, a network. The relation grants nothing on its own: no reading across members, no shared licence, no inherited payment method.",
    "noChildren": "No accounts sit under this one.",
    "noCompany": "No HubSpot company recorded",
    "noParent": "Not part of a group",
    "notFound": "Account not found.",
    "openIn": "Open in {{system}}",
    "parent": "Parent account",
    "partOf": "Part of",
    "saved": "Saved.",
    "searchCompanyEmpty": "No company found.",
    "searchCompanyMin": "Type at least three characters.",
    "searchCompanyPlaceholder": "Name or domain …",
    "searching": "Searching …",
    "tenants": "Workspaces",
    "title": "Accounts",
    "unnamed": "Unnamed"
  }
}
